export default __webpack_public_path__ + "static/media/img-gt-mode-on-bg-uk_en.91e5851d.jpg";